import httpClient from './http.client';

const host = process.env.VUE_APP_API_URL;
httpClient.defaults.baseURL = process.env.VUE_APP_API_URL;

function request(path, params, options = {}) {
  const { showLoader = false, nameLoader = '' } = options || {};
  return new Promise((resolve, reject) => {
    httpClient
      .get(path, { params, showLoader, nameLoader })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(failHandler(err, true));
      });
  });
}

function post(path, params, options = {}) {
  const { showLoader = false, nameLoader = '' } = options || {};
  let data = JSON.parse(JSON.stringify(params)); //to clear vue observables

  return new Promise((resolve, reject) => {
    httpClient
      .post(path, data, { showLoader, nameLoader })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(failHandler(err));
      });
  });
}

function put(path, params, options = {}) {
  const { showLoader = false, nameLoader = '' } = options || {};
  let data = JSON.parse(JSON.stringify(params)); //to clear vue observables

  return new Promise((resolve, reject) => {
    httpClient
      .put(path, data, { showLoader, nameLoader })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(failHandler(err));
      });
  });
}

function destroy(path, options = {}) {
  const { showLoader = false, nameLoader = '' } = options || {};
  return new Promise((resolve, reject) => {
    httpClient
      .delete(path, { showLoader, nameLoader })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(failHandler(err, true));
      });
  });
}

function failHandler(error, req) {
  let ret = null;
  let msg = req ? '' : '';

  function msgParser(msg) {
    return msg; // window.getApp.$t(msg);
  }

  if (error.response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    ret = error.response.data;
    //    console.log('data', error.response.data);
    //    console.log('status', error.response.status);
    //    console.log('header', error.response.headers);
    msg += msgParser(error.response.data.msg) || error.response.statusText;
    if (msg) {
      msg = msgParser(msg);
    }
  } else if (error.request) {
    // The request was made but no response was received
    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
    // http.ClientRequest in node.js
    console.log('request', error.request);
  } else {
    // Something happened in setting up the request that triggered an Error
    console.log('Error', error.message);
    msg += String.fromCharCode(10) + error.message;
  }
  // console.log('config', error.config);

  // Give feedback

  return ret;
}

function postFormData(path, params, options = {}) {
  const { showLoader = false, nameLoader = '', headers = {} } = options || {};
  let data = params;

  return new Promise((resolve, reject) => {
    httpClient
      .post(path, data, { showLoader, nameLoader, headers })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(failHandler(err));
      });
  });
}

function putFormData(path, params, options = {}) {
  const { showLoader = false, nameLoader = '', headers = {} } = options || {};
  let data = params;

  return new Promise((resolve, reject) => {
    httpClient
      .put(path, data, { showLoader, nameLoader, headers })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(failHandler(err));
      });
  });
}

export default {
  host,
  request,
  post,
  put,
  destroy,
  postFormData,
  putFormData
};
